module.exports = __webpack_public_path__ + "img/landing_truck.08e87484.jpeg";